import React from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon';
import { LOADING } from '../Svgs';

const StyledIconParent = styled(Icon)`
    width: 60%;
    height: 60%;
`;

const StyledDiv = styled.div`
    height: 100%;
    width: 100%;
    display: ${props => props.theme.hidden ? 'none' : 'flex'};
    align-items: center;
    justify-content: center;
`;

interface LoadingProps {
    hidden?: boolean
}

export const Loading: React.FunctionComponent<LoadingProps> = (props): React.ReactElement => {

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    return (
        <StyledDiv className={`${stylingClassName}`} theme={{ hidden: props.hidden }}>
            <StyledIconParent>
                <Icon>{LOADING}</Icon>
            </StyledIconParent>
        </StyledDiv>
    );
}